import React from "react";
import { getPublicMessage, usePublicI18nOptional } from "../../PublicI18nContext";

// WCAG 2.4.1 (Bypass Blocks): visually hidden until focused, first tab stop
// on every public page. Moves focus into <main> so keyboard users land past
// any repeated chrome.
export default function SkipLink({ targetId = "main-content" }) {
  const i18n = usePublicI18nOptional();
  const t = i18n ? i18n.t : (key, vars) => getPublicMessage("en", key, vars);

  const handleClick = (event) => {
    const target = document.getElementById(targetId);
    if (target) {
      event.preventDefault();
      target.focus();
      target.scrollIntoView({ block: "start" });
      // Keep the fragment in the URL for parity with native anchor behavior.
      window.history.replaceState(null, "", `#${targetId}`);
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-[100] focus:rounded-md focus:bg-brand focus:px-4 focus:py-2 focus:text-brand-fg focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-brand-dark"
    >
      {t("shared.skipToContent")}
    </a>
  );
}
